import React from "react";

// styles
import * as Styled from './styles'
import * as SharedStyled from '../styles'
// libs
import { CSVLink } from "react-csv";
  // exporting excel
import ReactExport from "react-export-excel";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

function DownloadSection({ done, results }) {
    return (
        <Styled.DownloadContainer>
            { !done ? 
              <SharedStyled.DownloadButton
                fixed="down"
                theme={ !done && "off" }
                onClick={() => {
                    if ( !done ) {
                      alert('Data still loading')
                      return false 
                    }
                }}
              >
                Download excel
              </SharedStyled.DownloadButton>
              :
              <ExcelFile 
                filename="Grey_Literature_results" 
                element={
                  <SharedStyled.DownloadButton fixed="down">
                    Download excel
                  </SharedStyled.DownloadButton>
                }
              >
                <ExcelSheet data={ results } name="results">
                    <ExcelColumn label="Type" value="tipo"/>
                    <ExcelColumn label="Title" value="titulo"/>
                    <ExcelColumn label="Link" value="link"/>
                    <ExcelColumn label="Date" value="data"/>
                    <ExcelColumn label="Author" value="autor"/>
                </ExcelSheet>
              </ExcelFile>
            }
            
            <CSVLink 
              data={ results } 
              filename={"Grey_Literature_results.csv"}
              onClick={() => {
                if ( !done ) {
                  alert('Data still loading')
                  return false 
                }
              }}
              headers={[
              {label: "Type", key:"tipo"},
              {label: "Title", key:"titulo"},
              {label: "Link", key:"link"},
              {label: "Date", key:"data"},
              {label: "Author", key:"autor"},
            ]}>
              <SharedStyled.DownloadButton
                fixed="down"
                theme={ !done && "off" }
              >
                Download csv
              </SharedStyled.DownloadButton>
            </CSVLink>
        </Styled.DownloadContainer>
    );
}

export default DownloadSection;
